import React from "react";

interface Props {
  children: any
}

const TextScrollX: React.FunctionComponent<Props> = ({ children }) => {
  return (
    <span style={{ overflowX: "auto" }}>
      <p style={{ width: "max-content", padding: "0 1rem" }}>{children}</p>
    </span>
  );
};

export default TextScrollX;
